import React, { createContext, useState } from 'react';

export const ThemeContext = createContext({
	variant: 'standard',
	mobileMenuContext: false,
	setMobileMenuContext: (mobileMenu: boolean) => {},
});

export default function Provider({
	children,
	variant,
}: {
	children: React.ReactNode;
	variant: 'standard' | 'altaccent';
}) {
	const [mobileMenuContext, setMobileMenuContext] = useState(false);

	return (
		<ThemeContext.Provider
			value={{ variant, mobileMenuContext, setMobileMenuContext }}
		>
			{children}
		</ThemeContext.Provider>
	);
}
